import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Section from '../components/common/Section';

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const ProductCard = styled.div`
  background-color: white;
  border-radius: ${props => props.theme.borderRadius.medium};
  overflow: hidden;
  box-shadow: ${props => props.theme.shadows.medium};
  transition: transform ${props => props.theme.transitions.medium};
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const ProductImage = styled.div`
  height: 200px;
  background-color: ${props => props.theme.colors.lightGray};
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
`;

const ProductContent = styled.div`
  padding: 1.5rem;
`;

const ProductTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.primary};
`;

const ProductDescription = styled.p`
  color: ${props => props.theme.colors.lightText};
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const ProductLink = styled(Link)`
  display: inline-block;
  color: ${props => props.theme.colors.primary};
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Products = () => {
  const { t } = useTranslation();
  
  const products = [
    {
      title: t('products.pim.title'),
      description: t('products.pim.subtitle'),
      image: '/images/products/pim.jpg',
      link: '/products/pim'
    },
    {
      title: t('products.dam.title'),
      description: t('products.dam.subtitle'),
      image: '/images/products/dam.jpg',
      link: '/products/dam'
    },
    {
      title: t('products.mdm.title'),
      description: t('products.mdm.subtitle'),
      image: '/images/products/mdm.jpg',
      link: '/products/mdm'
    },
    {
      title: t('products.cdp.title'),
      description: t('products.cdp.subtitle'),
      image: '/images/products/cdp.jpg',
      link: '/products/cdp'
    }
  ];
  
  return (
    <Section 
      title={t('products.title')} 
      subtitle={t('products.subtitle')}
    >
      <p>{t('products.content')}</p>
      
      <ProductGrid>
        {products.map((product, index) => (
          <ProductCard key={index}>
            <ProductImage image={product.image} />
            <ProductContent>
              <ProductTitle>{product.title}</ProductTitle>
              <ProductDescription>{product.description}</ProductDescription>
              <ProductLink to={product.link}>
                了解更多 &rarr;
              </ProductLink>
            </ProductContent>
          </ProductCard>
        ))}
      </ProductGrid>
    </Section>
  );
};

export default Products;